import React from 'react';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import classes from './item-tracking-numbers-popup.scss';
class ItemTrackingNumbersPopup extends React.Component {
  renderContent() {
    const {
      ksTrackings,
      orderNumber
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: classes.greenHeader
    }, "order"), /*#__PURE__*/React.createElement("div", {
      className: classes.header
    }, "#", orderNumber), /*#__PURE__*/React.createElement("div", {
      className: classes.tableContainer
    }, /*#__PURE__*/React.createElement("table", {
      className: classes.table
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      className: classes.headerCell
    }, "Name"), /*#__PURE__*/React.createElement("th", {
      className: classes.headerCell
    }, "Tracking number "))), /*#__PURE__*/React.createElement("tbody", null, ksTrackings ? ksTrackings.map((tracking, index) => /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("th", {
      className: classes.cell
    }, tracking.name), /*#__PURE__*/React.createElement("th", {
      className: classes.cell
    }, /*#__PURE__*/React.createElement("a", {
      className: classes.link,
      target: "_blank",
      rel: "noreferrer",
      href: `https://www.ups.com/WebTracking/track?loc=en_us&track=yes&trackNums=${tracking.trNum}`
    }, "#", tracking.trNum)))) : null))));
  }
  render() {
    const {
      onClose
    } = this.props;
    return /*#__PURE__*/React.createElement(ControlDialog, {
      open: true,
      onRequestClose: onClose,
      content: this.renderContent()
    });
  }
}
export default ItemTrackingNumbersPopup;